  /**
 * @module  Experience/Softgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/* tslint:disable: no-loop-func max-file-line-count*/
// Core Libraries
import { Component, OnInit, Input, Output, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Wove } from 'aspect.js/';
import { SafeHtml } from '@angular/platform-browser';

// Interfaces
import { BrowsePlanConfig, Tooltip } from '@core/aem/interfaces/shop/browse-plan.interface';
import {
  FamilyPlan,
  GrandfatheredCategory,
} from '@experience/shop/softgoods/interfaces/family-plan.interface';
import { APIError } from '@support/api/common/error.interface';
import { PlanOption } from '@support/api/proxies/responses/api-2117.interface';
import { CartItem } from '@support/api/proxies/responses/api-cart-response.interface';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { LineDeivceDetails } from '@experience/shop/product-selector/interfaces/product-selector.interface';

// Services
import { UserService } from '@support/shared/services/user.service';
import { MatchmediaService } from '@core/public';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';

// Constants
import {
  SHARED_BROWSE_COMPONENTS,
  SERVICES_AND_PLANS,
  SHARED_BROWSE_CONSTANTS,
} from '@experience/shop/shared-browse/constants/shared-browse.constants';
// PDL
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { Subject } from 'rxjs';
import { StaticModal } from '@support/shared/widgets/interfaces/static-modal.interface';

@Wove({ moduleName: SHARED_BROWSE_COMPONENTS.PLAN_FAMILY_MODULE })
@Component({
  selector: 'tmo-unlimited-data-plans',
  templateUrl: './unlimited-data-plans.component.html',
})
export class UnlimitedDataPlansComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  /**
   *  stores change in zip code flag
   */
  public updateFamiyPlansData: boolean;

  /**
   *  check updateFamily plans
   */
  @Input()
  public set updateFamiyPlans(value: boolean) {
    this.updateFamiyPlansData = value;
  }

  /**
   * Stores value of Selected Family
   */
  public selectedFamily: number;

  /**
   *  stores value in case no plan needed
   */
  public isNoPlanNeeded: boolean;
  /**
   * Flag to check isAddLine
   */
  @Input() public isAddLine: boolean;
  /**
   *  softGoodsAEM content
   */
  @Input() public softGoodsAEMContent: object;
  /**
   * Flag to check showToolTip
   */
  @Input() public showToolTip: boolean;
  /**
   * Configurable AEM data passed from parent component
   */
  @Input() public aemContent: BrowsePlanConfig;
  /**
   * Flag to check whether prepaid
   */
  @Input() public isPrepaid: boolean;
  /**
   * Flag to check whether the plans are displayed on Product Selector
   */
  @Input() public isProductSelector?: boolean;
  /**
   * Flag to check if calling from CPS
   */
  @Input() public isCPS?: boolean;
  /**
   * Emits selected plan
   */
  @Output() public selectedPlan: EventEmitter<PlanOption>;
  /**
   * Emits Selected plan option Id
   */
  @Output() public selectedPlanOptionId: EventEmitter<string>;

  /**
   * Emits noResultsError Emitter
   */
  @Output() public noResultsError: EventEmitter<boolean>;
  /**
   * Stores value of selected plan Id
   */
  @Input()
  public set selectedPlanOfferId(value: string) {
    this.selectedPlanId = value;
  }

  @Input() set noPlanNeeded(value: boolean) {
    this.isNoPlanNeeded = value;
    if (this.isNoPlanNeeded) {
      this.selectedPlanFamilyCode = null;
    } else if (this.isNoPlanNeeded === false) {
      this.selectedPlanFamilyCode = '';
    }
  }

  /**
   * Output variable to notify whether we are waiting for Plan API's response
   */
  @Output() public isResponseAwaited: EventEmitter<boolean>;
  /**
   * Flag to see open or close modal
   */
  public seeMoreModal: boolean;
  /**
   * model to store dynamic data
   */
  public modal: DynamicModal;

  /**
   * Event Emitter to trigger events on click of anchor
   */
  public triggerEvent: EventEmitter<Object>;
  /**
   * Stores value of Selected Plan Name
   */
  @Input() public selectedPlanName: PlanOption;

  @Input() public familyPlanOptions: PlanOption[];
  /**
   * Stores value to check Selected Plan
   */
  public planDeselected: boolean;
  /**
   * Stores value of cart Id
   */
  public cartId: string;
  /**
   * Condition to check change Entry
   */
  public changeEntry: boolean;
  /**
   * Condition to check seeMore Limit
   */
  public seeMore: number;
  /**
   * Stores value of Family Plan data
   */
  @Input() public familyPlanData: FamilyPlan[];

  /**
   * Stores boolean for whether checkbox is checked
   *
   * @type {boolean}
   * @memberof UnlimitedDataPlansComponent
   */
  public checked: boolean;
  /**
   * Stores boolean for whether checkbox is disabled
   * @type {boolean}
   * @memberof UnlimitedDataPlansComponent
   */
  public disabled: boolean;
  /**
   * Stores value of selected plan Id
   */
  public selectedPlanId: string;
  /**
   * Flag to check if assisted flow
   */
  // public isAssistedFlow: boolean;
  /**
   * Stores grandfathered plans for CPS flow
   */
  public grandFatheredPlans: GrandfatheredCategory;
  /**
   * variable to hold selected plan's family
   */
  @Input() public selectedPlanFamilyCode: string;
  /**
   * Constant to hold Grandfathered category name
   */
  public grandfatheredConst: string;
  /**
   * To check if the flow is authorized
   */
  public isAuthFlow: boolean;
  /**
   * Spinner controller
   */
  public showSpinner: boolean;
  /**
   * currentLine ID to be sent when adding plan to cart
   */
  public currentLineId: number;
  /**
   * To clear out all the subscribers
   */
  private ngUnsubscribe: Subject<void>;

  /**
   * Stores API error message
   */
  public errorMessage: APIError[];
  /**
   * Flag to show no results error message
   */
  public noResults: Boolean;
  /**
   * Stores tourist plan constant
   */
  public touristPlan: string;

  /**
   * Stores focused tileId details
   */
  public focusedTileId: LineDeivceDetails;
  /**
   * Boolean to check if user is on phone
   */
  public isPhone: boolean;
  /**
   * Variable to hold conflicting services
   */
  public conflictingPlanServicesNotification: string;
  /**
   * Variable to check if it is add a fan flow
   */
  @Input() public isAddAFan: boolean;
  /**
   * Emits edited plan status
   */
  @Output() public isPlanEdited: EventEmitter<boolean>;
  /**
   * Variable to hold conflicting services
   */
  public conflictingActiveServices: CartItem[];
  /**
   * Stores selected plan name
   */
  public selectedPlanLabel: string;
  /**
   * Stores selected plan amount
   */
  public selectedAmount: string;
  /**
   * Stores customer id
   */
  public customerId: string;
  @Input() public allowEdit: boolean;
  // @Input() public planId: string;
  @Input() public set planId(planId: string) {
    this.planSelectedId = planId;
  }
  // public isWebChannel: boolean;
  public pdlData: object;
  public isModalNameNeeded: boolean;
  public planSelectedId: String;
  @Output() public routeToCart: EventEmitter<boolean>;
  @Output() public showPlanDetailModal: EventEmitter<PlanOption>;
  @Input() public isEdit: boolean;
  public planSelectedIdCheck: String;
  public tooltipList: Tooltip[];
  @Input() public tmobilePrepaidPlanDetails: FamilyPlan;
  public pricingDisclaimer: string;
  @Input() public fccLabelLinkText: string;
  @Input() public fccLabelLinkUrl: string;
  /*
   * promotion banner header text and icon
   */
  @Input() public promotionTagIconTemplate: SafeHtml;
  @Input() public planPromotions: { [key: string]: string } = {};
  @Input() public autopayDiscountDetailsModal: StaticModal;
  @Input() public showAutoPayDiscountContent: boolean;
  constructor(
    private objectService: ObjectService,
    public routeSnapshot: ActivatedRoute,
    public userService: UserService,
    public matchMediaService: MatchmediaService,
    public pdlService: PdlService,
    public activatedRoute: ActivatedRoute
  ) {
    super(pdlService, activatedRoute);
    this.selectedPlan = new EventEmitter<PlanOption>();
    this.selectedPlanOptionId = new EventEmitter<string>();
    this.isResponseAwaited = new EventEmitter<boolean>();
    this.noResultsError = new EventEmitter<boolean>();
    this.isPlanEdited = new EventEmitter<boolean>();
    this.planDeselected = false;
    this.modal = {
      disableDismiss: false,
      disableEsc: true,
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: true,
      modalName: 'plan-family-modal',
    };
    this.seeMoreModal = this.isAuthFlow = false;
    this.grandfatheredConst = SERVICES_AND_PLANS.GRANDFATHERED;
    this.touristPlan = SHARED_BROWSE_CONSTANTS.touristPlan;
    this.noResults = false;
    this.isNoPlanNeeded = false;
    this.isPhone = false;
    this.allowEdit = false;
    this.routeToCart = new EventEmitter<boolean>();
    this.showPlanDetailModal = new EventEmitter<PlanOption>();
    this.tooltipList = [];
  }

  /**
   * Loads the initial configuration of Plan-Family page
   * @returns void
   */
  public ngOnInit(): void {
    const tooltipArray = this.objectService.get(this.aemContent, 'unlimitedPlanTooltip', '');
    this.tooltipList = tooltipArray ? JSON.parse(tooltipArray) : [];
    this.planSelectedIdCheck = this.planSelectedId;
    this.changeEntry = this.updateFamiyPlansData;
    this.isPhone = this.matchMediaService.isPhone();
    if (this.customerId) {
      this.isAuthFlow = true;
    }
    this.pricingDisclaimer =
      (this.aemContent &&
        this.aemContent.planFamiliesContent &&
        JSON.parse(this.aemContent.planFamiliesContent)[this.tmobilePrepaidPlanDetails.familyId]
          .DCC_pricingDisclaimer) ||
      '';
  }

  /**
   * Method to destroy service data.
   * @returns void
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.seeMoreModal = false;
  }

  /**
   * Showing of modal on toggle event
   * @param event : toggle event
   * @param familyDetails
   * @returns void
   */
  public updateSelectedPlan(selectedPlan: PlanOption): void {
    this.planSelectedIdCheck = null;
    this.selectedPlan.emit(selectedPlan);
    if (!this.isProductSelector) {
      this.planSelectedId = selectedPlan.planOptionSelectorId;
    }
  }

  public goToCart(): void {
    this.routeToCart.emit(true);
  }

  public showPlanDetailsModal(selectedPlan: PlanOption): void {
    this.showPlanDetailModal.emit(selectedPlan);
  }

  /**
   * Toggle AutoPay Discount details Modal display
   * @param openModal 
   */
  public toggleAutopayDiscountDetailsModal(openModal: boolean): void {
    this.autopayDiscountDetailsModal.toggleModalEmitter.emit({open: openModal, close: !openModal});
  }

}
